enum mixPanelEvents {
    LANDED = 'Landed',
    SEARCH = 'Searched',
    AUTH_STARTED = 'Authentication Started',
    AUTH_FINISHED = 'Authentication Finished',
    LOGGED_OUT = 'Logged Out',
    BID = 'Bid',
    BUY = 'Bought',
    ENQUIRIED = 'Enquiried',
    LANDED_TO_PDP = 'Landed To PDP',
    LANDED_TO_ENQUIRY_RESPONSE = 'Landed to Enquiry Response',
    CLICKED_ON_DEAL_CARD = 'Clicked On Deal Card',
    BUTTON_CLICKED = 'Button Clicked',
    FORM_SUBMITTED = 'Form Submitted',
    DIRECT_PURCHASE_ENQUIRY = 'Direct Purchase Enquiry',
    INPUT_FOCUSED = 'Input Focused',
    INPUT_FILLED = 'Input Filled',
    SELECT_INPUT_FOCUSED = 'Select Input Focused',
    SELECT_INPUT_FILLED = 'Select Input Filled',
    SCROLLED = 'Scrolled',
    API_CALLED = 'Backend API Called',
    ORDERED = 'Ordered Placed',
    TO_WA_CHAT = 'To WA Chat'
}

export enum MixPanelConstants {
    SUCCESS = 'success',
    FAILED = 'failed',
    DROPPED = 'Dropped',
    LOGGED_IN = 'Logged In',
    REGISTERED = 'Registered',
    STANDARD = 'Standard',
    GOOGLE_LOGIN = 'Google',
}

export default mixPanelEvents

